import { render, staticRenderFns } from "./ResolDeltaSolMxPlus_1d00.vue?vue&type=template&id=882f86ba&"
import script from "./ResolDeltaSolMxPlus_1d00.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolMxPlus_1d00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports